// @ts-check

/** @type {typeof import('./types').ConfigurationParameterReturnTypeEnum} */
export const ConfigurationParameterReturnType = Object.freeze({
  STRING: 0,
  NUMBER: 1,
  BOOLEAN: 2,
  OBJECT: 3,
  JSON: 4,
});

/** @type {typeof import('./types').ConfigurationParameterSourceEnum} */
export const ConfigurationParameterSource = Object.freeze({
  ERP: 0,
  WebService: 1,
});
